import { CONFIG_VARS } from "../constants/configuration";
import {
  useGetSchoolDetailsMutation,
  useLsqONsuccesPaymentMutation,
  useTalkToExpertActivityMutation,
  useLeadChaptersMutation,
  useBookDemoLsqMutation
} from "../store/ApiMutaion";
import { getUserInfo, getDeviceAndLocation, getSelectedEventsDetails } from "../store/auth/selectors";
import { setSelectedEventsDetails } from "../store/auth/auth.slice";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { trackGatedReport } from "../webengage/webengageService";

const useLeadCapture = () => {
  const [deviceDetails, setDeviceDetails] = useState({});
  const [schoolDetails] = useGetSchoolDetailsMutation();
  const [lsqOnSuccessPayment] = useLsqONsuccesPaymentMutation();
  const [talkToExpertActivity] = useTalkToExpertActivityMutation();
  const [leadChapters] = useLeadChaptersMutation();
  const [bookDemoLsq] = useBookDemoLsqMutation();
  const actualSource = sessionStorage.getItem("url");

  const dispatch = useDispatch();
  const deviceDetials = useSelector(getDeviceAndLocation);
  const userInfo = useSelector(getUserInfo);
  const currentExamDetails = useSelector(getSelectedEventsDetails);

  useEffect(() => {
    if (deviceDetials) {
      setDeviceDetails(deviceDetials);
    }
  }, [deviceDetials]);

  // Helper function to format phone number correctly
  const formatPhoneNumber = (isdCode, phone) => {
    const cleanIsd = isdCode?.toString().replace(/\D/g, "") || "";
    const cleanPhone = phone?.toString().replace(/\D/g, "") || "";
    const formattedIsd = cleanIsd.startsWith("+") ? cleanIsd : `+${cleanIsd}`;
    return `${formattedIsd}-${cleanPhone}`;
  };

  const addFieldIfExists = (obj, key, value) => {
    if (value !== null && value !== undefined && value !== "" && value !== "N/A") {
      obj[key] = value;
    }
    return obj;
  };

  const cropUrl = (url) => {
    if (!url) return "";
    const startIndex = url.indexOf(".com");
    if (startIndex === -1) return url;
    const trimmedUrl = url.slice(startIndex + 4);
    return trimmedUrl.length > 200 ? trimmedUrl.slice(-200) : trimmedUrl;
  };

  const date = new Date();
  const formattedDate = date.toISOString().slice(0, 19).replace("T", " ");

  const handleLoginLeadCaptur = async (data) => {
    try {
      const res = schoolDetails(data).unwrap();
      return res;
    } catch (error) {
      console.error("Error pushing LSQ event:", error);
    }
  };

  const handleLeadCapture = async (data, utmSource) => {
    if (!data?.data) return;

    let res = null;
    try {
      const schoolRes = await schoolDetails(data?.data?.school_id).unwrap();
      res = schoolRes?.data;
    } catch (error) {
      console.error("Error fetching school details:", error);
    }

    const payload = deviceDetails;

    const customAttributeFields = {};
    if (payload?.device_attributes?.length > 0) {
      const deviceAttributes = payload.device_attributes
        .map((attr) => {
          if (
            attr.value &&
            attr.value !== null &&
            attr.value !== undefined &&
            attr.value !== "" &&
            attr.value !== "N/A"
          ) {
            const attributeObj = {};
            addFieldIfExists(attributeObj, "Attribute", attr.name);
            addFieldIfExists(attributeObj, "Value", attr.value);
            return Object.keys(attributeObj).length > 0 ? attributeObj : null;
          }
          return null;
        })
        .filter(Boolean);

      if (deviceAttributes.length > 0) {
        customAttributeFields.mx_Mobile_device = deviceAttributes;
      }
    }

    const leadFields = {};
    addFieldIfExists(leadFields, "mx_Actual_source_URL", cropUrl(actualSource));
    addFieldIfExists(leadFields, "mx_Student_Login_ID", data?.data?.admission_id);
    addFieldIfExists(leadFields, "mx_Grade", data?.data?.grade_id);
    addFieldIfExists(leadFields, "mx_UDISE_Code", data?.data?.udise_code);
    if (data?.data?.grade_id >= 1 && data?.data?.grade_id <= 5) {
      leadFields.mx_Primary_Target_Exam = "Foundation Test";
    } else if (data?.data?.grade_id >= 6 && data?.data?.grade_id <= 8) {
      leadFields.mx_Primary_Target_Exam = "Aptitude Test";
    }

    addFieldIfExists(leadFields, "mx_Inmobius_School_Code", data?.data?.school_id);
    addFieldIfExists(leadFields, "mx_School_Name", res?.school_name);
    addFieldIfExists(leadFields, "mx_Board", res?.board);
    addFieldIfExists(leadFields, "mx_Inmobius_School_Address", res?.address);

    const city = payload.city && payload.city !== "N/A" ? payload.city : res?.city;
    addFieldIfExists(leadFields, "mx_City", city);
    addFieldIfExists(leadFields, "mx_School_City", res?.city);

    const state = res?.state;
    addFieldIfExists(leadFields, "mx_State", state);
    addFieldIfExists(leadFields, "mx_School_State", res?.state);
    addFieldIfExists(leadFields, "mx_Country", res?.country);
    addFieldIfExists(leadFields, "mx_School_Pincode", res?.pincode);
    addFieldIfExists(leadFields, "mx_PinCode", res?.pincode);
    addFieldIfExists(leadFields, "mx_Fees", res?.fee);
    addFieldIfExists(leadFields, "mx_Tier", res?.tier);
    addFieldIfExists(leadFields, "mx_Category", res?.category);

    const activityFields = {};

    addFieldIfExists(activityFields, "mx_Custom_1", cropUrl(actualSource));
    addFieldIfExists(activityFields, "mx_Custom_2", payload?.webType);
    addFieldIfExists(activityFields, "mx_Custom_3", "InMobius");
    addFieldIfExists(activityFields, "mx_Custom_4", payload?.latitude);
    addFieldIfExists(activityFields, "mx_Custom_5", payload?.longitude);
    addFieldIfExists(activityFields, "mx_Custom_6", payload?.ip_address);

    if (utmSource) {
      addFieldIfExists(activityFields, "mx_Custom_7", utmSource);
    }

    const body = {
      type: "LEAD_ACTIVITY",
      mode: "LSQ",
      env: CONFIG_VARS.environment,
      ActivityEvent: 213,
      phone: formatPhoneNumber(data?.data?.isd_code, data?.data?.phone),
      ActivityDateTime: formattedDate,
      FirstName: data?.data?.first_name,
      LastName: data?.data?.last_name,
      GradeID: data?.data?.grade_id,
      Source: "InMobius Leads"
    };

    if (Object.keys(customAttributeFields).length > 0) {
      body.custom_attribute_fields = customAttributeFields;
    }

    if (Object.keys(leadFields).length > 0) {
      body.LeadFields = leadFields;
    }

    if (Object.keys(activityFields).length > 0) {
      body.ActivityFields = activityFields;
    }

    try {
      await leadChapters(body);
    } catch (error) {
      console.error("Error pushing LSQ event:", error);
    }
  };

  const handelAlerbarLead = async (param) => {
    if (!userInfo) return;

    const payload = deviceDetails;
    const activityFields = {};

    addFieldIfExists(activityFields, "mx_Custom_1", userInfo?.grade_id);
    addFieldIfExists(activityFields, "mx_Custom_2", "InMobius");
    addFieldIfExists(activityFields, "mx_Custom_3", payload?.webType);
    addFieldIfExists(activityFields, "mx_Custom_4", payload?.latitude);
    addFieldIfExists(activityFields, "mx_Custom_5", payload?.longitude);
    addFieldIfExists(activityFields, "mx_Custom_6", payload?.ip_address);
    addFieldIfExists(activityFields, "mx_Custom_7", param?.img_link);
    addFieldIfExists(activityFields, "mx_Custom_8", param?.redirect_link);
    addFieldIfExists(activityFields, "mx_Custom_9", userInfo.school_id);
    addFieldIfExists(activityFields, "mx_Custom_10", param?.source);

    const body = {
      type: "ACTIVITY",
      mode: "LSQ",
      env: CONFIG_VARS.environment,
      ActivityEvent: 354,
      phone: formatPhoneNumber(userInfo?.isd_code, userInfo?.phone),
      ActivityDateTime: formattedDate,
      FirstName: userInfo?.first_name,
      LastName: userInfo?.last_name,
      GradeID: userInfo?.grade_id,
      Source: "InMobius Leads"
    };

    if (Object.keys(activityFields).length > 0) {
      body.ActivityFields = activityFields;
    }

    try {
      await lsqOnSuccessPayment(body);
    } catch (error) {
      console.error("Error pushing LSQ event:", error);
    }
  };

  const formatDateTime = (date, time, userIsdCode) => {
    try {
      const months = {
        jan: 0,
        feb: 1,
        mar: 2,
        apr: 3,
        may: 4,
        jun: 5,
        jul: 6,
        aug: 7,
        sep: 8,
        oct: 9,
        nov: 10,
        dec: 11
      };

      // Parse date
      const [month, day] = date.split(" ");
      const year = new Date().getFullYear();

      const monthIndex = months[month?.toLowerCase()];
      if (monthIndex === undefined) {
        throw new Error(`Invalid month: ${month}`);
      }

      const [timePart, period] = time.trim().toLowerCase().split(" ");
      let [hour, minute] = timePart.split(":");

      hour = parseInt(hour, 10);
      minute = minute ? parseInt(minute, 10) : 0;

      if (isNaN(hour)) throw new Error("Invalid hour");

      // Convert to 24-hour format
      let hour24 = hour;
      if (period === "pm" && hour24 !== 12) hour24 += 12;
      if (period === "am" && hour24 === 12) hour24 = 0;

      // Create date object (LOCAL time)
      let dateObj = new Date(year, monthIndex, parseInt(day, 10), hour24, minute, 0);

      if (isNaN(dateObj.getTime())) {
        throw new Error("Invalid date created");
      }

      const cleanIsd = userIsdCode?.toString().replace(/\D/g, "");

      if (cleanIsd === "971") {
        // subtract 7 hour
        dateObj = new Date(dateObj.getTime() - 7 * 60 * 60 * 1000);
      } else {
        // subtract 5 hour 30 M
        dateObj = new Date(dateObj.getTime() - 5.5 * 60 * 60 * 1000);
      }

      const pad = (n) => String(n).padStart(2, "0");

      const formatted =
        dateObj.getFullYear() +
        "-" +
        pad(dateObj.getMonth() + 1) +
        "-" +
        pad(dateObj.getDate()) +
        " " +
        pad(dateObj.getHours()) +
        ":" +
        pad(dateObj.getMinutes()) +
        ":" +
        pad(dateObj.getSeconds());

      return {
        activityDateTime: formatted,
        scheduledDateTime: formatted
      };
    } catch (error) {
      console.error("Error formatting date time:", error);
      throw error;
    }
  };
  const handleTalkToExpertLeadCapture = async ({
    user,
    selectedDate,
    selectedTime,
    selectedAttendees,
    schoolName,
    deviceLocation
  }) => {
    if (!user) return;
    console.log(selectedTime);
    const { scheduledDateTime } = formatDateTime(selectedDate, selectedTime, user?.isd_code);

    const activityFields = {};
    addFieldIfExists(activityFields, "mx_Custom_2", user?.last_name);
    addFieldIfExists(activityFields, "mx_Custom_3", user?.first_name);
    addFieldIfExists(activityFields, "mx_Custom_6", scheduledDateTime);
    addFieldIfExists(
      activityFields,
      "mx_Custom_7",
      selectedAttendees && selectedAttendees.length > 0 ? selectedAttendees.join(",") : null
    );
    addFieldIfExists(activityFields, "mx_Custom_12", user?.exam_type);
    addFieldIfExists(activityFields, "mx_Custom_13", user?.grade_id);
    addFieldIfExists(activityFields, "mx_Custom_20", schoolName);
    addFieldIfExists(activityFields, "mx_Custom_21", user?.school_id);
    addFieldIfExists(activityFields, "mx_Custom_22", deviceLocation?.latitude);
    addFieldIfExists(activityFields, "mx_Custom_23", deviceLocation?.longitude);
    addFieldIfExists(activityFields, "mx_Custom_24", "InMobius");
    addFieldIfExists(activityFields, "mx_Custom_25", deviceLocation?.webType);

    const payload = {
      type: "ACTIVITY",
      mode: "LSQ",
      env: CONFIG_VARS.environment,
      ActivityEvent: 266,
      phone: formatPhoneNumber(user?.isd_code, user?.phone),
      ActivityDateTime: formattedDate,
      FirstName: user?.first_name,
      LastName: user?.last_name || "",
      GradeID: user?.grade_id,
      Source: "InMobius Leads"
    };

    if (Object.keys(activityFields).length > 0) {
      payload.ActivityFields = activityFields;
    }

    return await talkToExpertActivity(payload);
  };

  const handelTakeTestLSQ = async () => {
    if (!userInfo) return;

    let schoolRes = null;
    try {
      const res = await schoolDetails(userInfo?.school_id).unwrap();
      schoolRes = res?.data;
    } catch (error) {
      console.error("Error fetching school details:", error);
    }

    const customAttributeFields = {};
    if (deviceDetails?.device_attributes?.length > 0) {
      const deviceAttributes = deviceDetails.device_attributes
        .map((attr) => {
          if (
            attr.value &&
            attr.value !== null &&
            attr.value !== undefined &&
            attr.value !== "" &&
            attr.value !== "N/A"
          ) {
            const attributeObj = {};
            addFieldIfExists(attributeObj, "Attribute", attr.name);
            addFieldIfExists(attributeObj, "Value", attr.value);
            return Object.keys(attributeObj).length > 0 ? attributeObj : null;
          }
          return null;
        })
        .filter(Boolean);

      if (deviceAttributes.length > 0) {
        customAttributeFields.mx_Mobile_device = deviceAttributes;
      }
    }

    const leadFields = {};
    addFieldIfExists(leadFields, "mx_Actual_source_URL", cropUrl(actualSource));
    addFieldIfExists(leadFields, "mx_City", deviceDetails?.city);
    addFieldIfExists(leadFields, "mx_State", schoolRes?.state);
    addFieldIfExists(leadFields, "mx_UDISE_Code", userInfo?.udise_code || schoolRes?.udise_code);
    addFieldIfExists(leadFields, "mx_Grade", userInfo?.grade_id);
    const activityFields = {};
    addFieldIfExists(activityFields, "mx_Custom_21", deviceDetails?.latitude);
    addFieldIfExists(activityFields, "mx_Custom_22", deviceDetails?.longitude);
    addFieldIfExists(activityFields, "mx_Custom_23", deviceDetails?.ip_address);

    const payload = {
      mode: "LSQ",
      type: "LEAD_ACTIVITY",
      env: CONFIG_VARS.environment,
      Source: "InMobius Leads",
      ActivityDateTime: formattedDate,
      FirstName: userInfo?.first_name,
      LastName: userInfo?.last_name || "",
      GradeID: userInfo?.grade_id,
      ActivityEvent: 213,
      phone: formatPhoneNumber(userInfo?.isd_code, userInfo?.phone)
    };

    if (Object.keys(customAttributeFields).length > 0) {
      payload.custom_attribute_fields = customAttributeFields;
    }

    if (Object.keys(leadFields).length > 0) {
      payload.LeadFields = leadFields;
    }

    if (Object.keys(activityFields).length > 0) {
      payload.ActivityFields = activityFields;
    }

    await leadChapters(payload);
  };

  const handleBookDemo = async ({
    user,
    selectedDate,
    selectedTime,
    selectedAttendees,
    schoolName,
    deviceLocation,
    crn_id,
    event_id,
    examName
  }) => {
    try {
      const { scheduledDateTime, activityDateTime } = formatDateTime(selectedDate, selectedTime, user?.isd_code);

      const activityFields = {};
      addFieldIfExists(activityFields, "mx_Custom_2", user?.last_name);
      addFieldIfExists(activityFields, "mx_Custom_3", user?.first_name);
      addFieldIfExists(activityFields, "mx_Custom_6", scheduledDateTime);
      addFieldIfExists(
        activityFields,
        "mx_Custom_7",
        selectedAttendees && selectedAttendees.length > 0 ? selectedAttendees.join(",") : null
      );
      addFieldIfExists(activityFields, "mx_Custom_12", user?.exam_type);
      addFieldIfExists(activityFields, "mx_Custom_13", user?.grade_id);
      addFieldIfExists(activityFields, "mx_Custom_20", schoolName);
      addFieldIfExists(activityFields, "mx_Custom_21", user?.school_id);
      addFieldIfExists(activityFields, "mx_Custom_22", deviceLocation?.latitude);
      addFieldIfExists(activityFields, "mx_Custom_23", deviceLocation?.longitude);
      addFieldIfExists(activityFields, "mx_Custom_24", "InMobius");
      addFieldIfExists(activityFields, "mx_Custom_25", deviceLocation?.webType);

      const payload = {
        lsq_activity: {
          type: "ACTIVITY",
          mode: "LSQ",
          env: CONFIG_VARS.environment,
          ActivityEvent: 266,
          phone: formatPhoneNumber(user?.isd_code, user?.phone),
          ActivityDateTime: activityDateTime || formattedDate,
          FirstName: user?.first_name,
          LastName: user?.last_name || "",
          GradeID: user?.grade_id,
          Source: "InMobius Leads",
          ActivityFields: activityFields,
          is_demo_booked: true
        },
        crn_id: crn_id || user?.crn_id,
        event_id: event_id
      };

      console.log("Book Demo Payload:", payload);

      const response = await bookDemoLsq(payload).unwrap();
      console.log("Book Demo Response:", response);

      if (response && currentExamDetails) {
        const updatedExamDetails = {
          ...currentExamDetails,
          is_demo_booked: true
        };
        dispatch(setSelectedEventsDetails(updatedExamDetails));
        console.log("Updated Redux store with is_demo_booked: true");

        if (examName && user) {
          trackGatedReport(examName, user);
          console.log("[WebEngage] Gated_Report triggered for exam:", examName);
        }
      }

      return response;
    } catch (error) {
      console.error("Error booking demo:", error);
      throw error;
    }
  };

  return {
    handleLeadCapture,
    handelAlerbarLead,
    handleTalkToExpertLeadCapture,
    handelTakeTestLSQ,
    handleBookDemo
  };
};

export default useLeadCapture;
